import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBase from "../customFetchBase";
import appConfig from "appconfig";

const apiUrl = appConfig.thiapiBaseUrl + appConfig.modules.hr;

export const personalTitleApi = createApi({
  reducerPath: "personalTitleApi",
  baseQuery: customFetchBase,
  tagTypes: ["PersonalTitle"],
  endpoints: (builder) => ({
    getPersonalTitles: builder.query({
      query: () => apiUrl + "/personaltitle",
      providesTags: ["PersonalTitle"],
    }),
    addPersonalTitle: builder.mutation({
      query: (formData) => ({
        url: apiUrl + "/personaltitle/",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["PersonalTitle"],
    }),
    updatePersonalTitle: builder.mutation({
      query: ({ id, ...formData }) => ({
        url: apiUrl + `/personaltitle/${id}/`,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["PersonalTitle"],
    }),
    partupdatePersonalTitle: builder.mutation({
      query: ({ id, ...formData }) => ({
        url: apiUrl + `/personaltitle/${id}/`,
        method: "PATCH",
        body: formData,
      }),
      invalidatesTags: ["PersonalTitle"],
    }),
    updatePersonalTitleSortOrder: builder.mutation({
      query: (formData) => ({
        url: appConfig.thiapiBaseUrl + appConfig.modules.tims + "/sortorder/",
        method: "PATCH",
        body: formData,
      }),
      invalidatesTags: ["PersonalTitle"],
    }),
    deletePersonalTitle: builder.mutation({
      query: (id) => ({
        url: apiUrl + `/personaltitle/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PersonalTitle"],
    }),
  }),
});

export const {
  useGetPersonalTitlesQuery,
  useAddPersonalTitleMutation,
  useUpdatePersonalTitleMutation,
  useUpdatePersonalTitleSortOrderMutation,
  usePartupdatePersonalTitleMutation,
  useDeletePersonalTitleMutation,
} = personalTitleApi;
